// extracted by mini-css-extract-plugin
module.exports = {"gallery":"gallery-module--gallery--D7OsD","galleryItem":"gallery-module--galleryItem--3dYz6","galleryItemCaption":"gallery-module--galleryItemCaption--14RDQ"};